import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EventExtraData } from '@cigna/chcp/shared/analytics-util';
import {
  ENVIRONMENT_CONFIG,
  EnvironmentConfig,
} from '@cigna/chcp/shared/environment-util';

@Component({
  selector: 'cigna-leave-chcp-dialog',
  templateUrl: './leave-chcp-dialog.component.html',
  styleUrls: ['./leave-chcp-dialog.component.scss'],
})
export class LeaveChcpDialogComponent {
  isAuth0 = false;

  constructor(
    public leaveChcpDialogRef: MatDialogRef<LeaveChcpDialogComponent>,
    @Inject(ENVIRONMENT_CONFIG) private envConfig: EnvironmentConfig,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      content: string;
      heading: string;
      link: string;
      partnerName: string;
      analytics?: {
        linkName: string;
        prop13: string;
        extra?: EventExtraData;
      };
    },
  ) {
    this.isAuth0 = this.envConfig.authMethod === 'auth0';
  }
}
